import React, {useState, useMemo, useEffect} from 'react';
import RadioItem from '../RadioItem';
import { CardForm, DefaultPaymentForm } from '../PaymentForms';
import MapToComponent from '../MapToComponent';
import PaymentFormFooter from '../PaymentFormFooter';
import Article from '../UI/AuxiliaryHoc/Article';


const preparePaymentData = (id, info) => {
  const paymentCards = id === 'creditCard'
    ? info?.bankCards?.card?.paymentAXTypes?.sort((a, b) => a.rank - b.rank)?.map(el => el.logoSrc)
    : [info.paymentCards]
  return {
    ...info,
    paymentCards,
    id
  }
}



const PaymentFormsWrap = ({
  payments,
  sendPayment,
  userData,
  toggleDetailsModal,
  securePaymentText,
}) => {
  const formId = 'payment-form'
  const [activePayment, setActivePayment] = useState(null)

  const handleChange = (e) => {
    const { value } = e.target;
    setActivePayment(value)
  };

  const paymentsList = useMemo(function () {
    return Object.entries(payments).map((data) => {
      const [id, info] = data;
      return preparePaymentData(id, info)
    }).sort((a, b) => a.order > b.order ? 1 : -1)
  }, [payments])

  const formFooterData = useMemo(function () {
    return {
      noticeLogos: payments.creditCard.bankCards.card.noticeLogos,
      partnerRedirection: payments.creditCard.partnerRedirection,
      confirmationInfo: payments.creditCard.confirmationInfo,
      confirmButton: payments.creditCard.confirmButton,
    }
  }, [payments])

  const paymentFormMap = [
    // { key: "payPal", component: PaypalForm },
    { component: CardForm, keyMask: "creditCard(_[a-zA-Z_]+)?" },
  ];

  useEffect(() => {
    if (paymentsList[0]?.id) {
      setActivePayment(paymentsList[0]?.id)
    }
  }, []);

  const onTermsClick = (e) => {
    e.preventDefault();

    if (
      e.target.getAttribute('href') === '#conditions' && toggleDetailsModal
    ) {
      toggleDetailsModal(true)
    }

    if (e.target.getAttribute('href') && e.target.getAttribute('href') !== '#conditions') {
      window.open(e.target.getAttribute('href'));
    }
  }

  return (
    <Article className="Payment__form" key="Payment__content">
      {paymentsList.map((item) => {
        return (
          <RadioItem
            key={item.id}
            id={item.id}
            isSingle={paymentsList.length < 2}
            checked={activePayment === item.id}
            title={item.name}
            onHandleChange={handleChange}
            icons={item.paymentCards}
          >
            <MapToComponent
              map={paymentFormMap}
              defaultComponent={DefaultPaymentForm}
              mapKey={item.id}
              formId={formId}
              data={item}
              sendPayment={sendPayment}
              userData={userData}
            />
          </RadioItem>
        );
      })}
      <PaymentFormFooter
        noticeLogos={formFooterData.noticeLogos}
        formId={formId}
        onClick={onTermsClick}
        partnerRedirection={formFooterData.partnerRedirection}
        confirmationInfo={formFooterData.confirmationInfo}
        confirmButton={formFooterData.confirmButton}
        securePaymentText={securePaymentText}
      />
    </Article>
  );
};

export default PaymentFormsWrap;
